import type { BlockWire, EffectDeclaration, BlockReaction } from '../core/types';
import type { BlockType } from '../core/constants';

export function expandWire(
  targetSemanticId: string,
  wire: BlockWire,
  targetBlockType?: BlockType,
): EffectDeclaration[] {
  const effects: EffectDeclaration[] = [];

  const refreshReaction: BlockReaction =
    targetBlockType === 'view' ? 'refetch' : 'refreshData';

  if (wire.refreshOn) {
    for (const source of wire.refreshOn) {
      effects.push({
        id: `wire:${targetSemanticId}:refreshOn:${source.block}:${source.event}`,
        source: {
          block: source.block,
          event: source.event,
          filter: source.filter,
        },
        target: {
          block: targetSemanticId,
          reaction: refreshReaction,
        },
        protocol: 'refresh',
      });
    }
  }

  if (wire.paramsFrom) {
    effects.push({
      id: `wire:${targetSemanticId}:paramsFrom:${wire.paramsFrom.block}:${wire.paramsFrom.event}`,
      source: {
        block: wire.paramsFrom.block,
        event: wire.paramsFrom.event,
      },
      target: {
        block: targetSemanticId,
        reaction: 'setParams',
      },
      protocol: 'param',
      mapping: wire.paramsFrom.mapping,
      debounceMs: wire.paramsFrom.debounceMs,
    });
  }

  if (wire.commands) {
    for (const cmd of wire.commands) {
      effects.push({
        id: `wire:${targetSemanticId}:cmd:${cmd.block}:${cmd.event}:${cmd.reaction}`,
        source: {
          block: cmd.block,
          event: cmd.event,
          filter: cmd.filter,
        },
        target: {
          block: targetSemanticId,
          reaction: cmd.reaction,
        },
        protocol: 'command',
        mapping: cmd.mapping,
      });
    }
  }

  return effects;
}
